// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import file06Icon from "@/assets/icons/file-06.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type File06IconProps = Omit<IconProps, "name">;

export function File06Icon(props: File06IconProps): React.ReactNode {
  return <Icon name={file06Icon} {...props} />;
}
